import { CommonActions } from "@react-navigation/native";

import { notify } from "@/components/shared/AppToast";
import { t } from "@/localization";
import { switchWorkspace } from "./actions";

// Switch to `owner`'s account (null: your own) and show it: its event list,
// or one event of it (`slug`) with the list under it. Nothing from the other
// account stays on the stack. Says why when the switch didn't happen.
export async function openWorkspace(
  navigation,
  owner,
  { slug = null, source = "switcher" } = {}
) {
  const result = await switchWorkspace(owner, { source });
  if (result.stale) return result;
  if (!result.ok) {
    notify.error(t("Couldn't switch accounts"), result.message);
    return result;
  }
  const routes = [{ name: "EventList" }];
  if (slug) routes.push({ name: "EventEdit", params: { slug } });
  navigation?.dispatch(
    CommonActions.reset({ index: routes.length - 1, routes })
  );
  return result;
}

// The event to open for an account entry: its only shared event, if that's
// all that was shared.
export const singleSharedSlug = (entry) =>
  entry && !entry.accountRole && entry.events?.length === 1
    ? entry.events[0].slug
    : null;
